// extracted by css-extract-rspack-plugin
export default {"cls1":"AutoCompleteResults-cls1_KoC","cls2":"AutoCompleteResults-cls2_wjZ AutoCompleteResults-cls1_KoC"};